import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import "./ModalLay.css";

var appElement = document.getElementById("root") || document.getElementById("example");
Modal.setAppElement(appElement);

/** ModalLayout
 * Descripción: Permite Desplegar un Modal con su respectivo contenido. Siempre envía la función para cerrar el modal al formulario recibido por props.
 * Props:
 * @name Se pasa la etiqueta con el icono que identifica al botón para abrir el modal.
 * @resumirModal Variable booleana que permite ver si se reanuda o no el modal una vez minimizado.
 * @tamanio Tamaño del modal
 * @title Título en el Modal
 * @funcionReanudar Función que cambia el valor de la variable resumirModal
 * @formulario Contenido del modal
 * @datosForm Props que se envían al contenido del modal (formulario).
 * @hiddenModal Prop externo para controlar apertura del modal
 * @Fclose Función para cerrar el modal desde el padre
 *
 */
const ModalLay = (props) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const Formulario = props.formulario;

  // Sincronizar con prop externo
  useEffect(() => {
    if (props.hiddenModal !== undefined) {
      setModalIsOpen(props.hiddenModal);
    }
  }, [props.hiddenModal]);

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    if (props.Fclose) {
      props.Fclose();
    }
  };

  return (
    <>
      <label className="transparent-input thumbnail" onClick={openModal}>
        {props.name}
      </label>
      <Modal
        closeTimeoutMS={50}
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        className="Modal"
        overlayClassName="ModalLayOverlay"
        ariaHideApp={false}
        style={
          props.resumirModal
            ? {
                overlay: { display: "none" },
                content: {
                  position: "relative",
                  top: "60px",
                  width:
                    window.screen.width > 900
                      ? props.tamanio
                      : window.screen.width - 20,
                  height: "auto",
                  margin: "auto",
                },
              }
            : {
                overlay: { display: "block" },
                content: {
                  position: "relative",
                  top: "60px",
                  width:
                    window.screen.width > 900
                      ? props.tamanio
                      : window.screen.width - 20,
                  height: "auto",
                  margin: "auto",
                },
              }
        }
      >
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title"> {props.title}</h4>
            <div class="btn-group">
              {["Modificar", "Nuevo"].includes(props.title) && (
                <button
                  type="button"
                  className="btn btn-primary fa fa-minus"
                  onClick={props.funcionReanudar}
                />
              )}
              <button
                type="button"
                className="btn btn-danger fa fa-close outline pill"
                onClick={closeModal}
              />
            </div>
          </div>
          <div className="modal-body">
            {modalIsOpen && <Formulario {...props.datosForm} cerrarModal={closeModal} />}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalLay;
